import {
  CreateSystemSettingInfoMutationVariables,
  CreateSystemSettingInfoMutation,
  UpdateSystemSettingInfoMutation,
  UpdateSystemSettingInfoMutationVariables,
  _Boolean,
  AnnouncementSetting,
} from '@/API';
import { UpdateSystemSettingInfoInput } from '@/appsync/graphql/systemSettingInfo';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import {
  createSystemSettingInfo as createSystemSettingInfoMutation,
  updateSystemSettingInfo as updateSystemSettingInfoMutation,
} from '@/graphql/mutations';
import { boolean2_BooleanEnum } from '@/utils/CommonUtils';

const createSystemSettingInfoInput = (tenant: string, landscape: string) => ({
  tenant: tenant,
  landscape: landscape,
  isMultilanguageEnabled: _Boolean._true,
  isJobSchedulerEnabled: _Boolean._true,
  isPortalEnabled: _Boolean._false,
  announcementSetting: AnnouncementSetting.UseV1,
});

export const updateSystemSettingInfo = async (
  param: UpdateSystemSettingInfoInput
): Promise<void> => {
  const updateVariables: UpdateSystemSettingInfoMutationVariables = {
    input: {
      tenant: param.tenant,
      landscape: param.landscape,
      isMultilanguageEnabled: boolean2_BooleanEnum(
        param.isMultilanguageEnabled
      ),
      isJobSchedulerEnabled: boolean2_BooleanEnum(param.isJobSchedulerEnabled),
      announcementSetting: param.announcementSetting,
    },
  };

  await graphqlQuery<
    UpdateSystemSettingInfoMutation,
    UpdateSystemSettingInfoMutationVariables
  >(updateSystemSettingInfoMutation, updateVariables);
};

export const updateIsPortalEnabledFalseAndIsJobSchedulerEnabledTrue = async (
  tenant: string,
  landscape: string
): Promise<void> => {
  const updateVariables: UpdateSystemSettingInfoMutationVariables = {
    input: {
      tenant: tenant,
      landscape: landscape,
      isPortalEnabled: _Boolean._false,
      isJobSchedulerEnabled: _Boolean._true,
    },
  };

  await graphqlQuery<
    UpdateSystemSettingInfoMutation,
    UpdateSystemSettingInfoMutationVariables
  >(updateSystemSettingInfoMutation, updateVariables);
};

export const createSystemSettingInfo = async (
  tenant: string,
  landscape: string
): Promise<void> => {
  const createVariables: CreateSystemSettingInfoMutationVariables = {
    input: {
      ...createSystemSettingInfoInput(tenant, landscape),
    },
  };
  await graphqlQuery<
    CreateSystemSettingInfoMutation,
    CreateSystemSettingInfoMutationVariables
  >(createSystemSettingInfoMutation, createVariables);
};
